import DashboardContainer from '../../containers/DashboardContainer';

const DashboardPage = () => {
  return <DashboardContainer />;
};

export default DashboardPage;
